// Matches emoji (incl. variation selectors, ZWJ sequences, skin-tone modifiers,
// and regional-indicator flag pairs).
const EMOJI_RE = /(\p{Regional_Indicator}\p{Regional_Indicator}|\p{Extended_Pictographic})(️|‍\p{Extended_Pictographic}|[\u{1F3FB}-\u{1F3FF}])*/gu;

const HTML_ESCAPES: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
const escapeHtml = (s: string) => s.replace(/[&<>"']/g, c => HTML_ESCAPES[c]!);

/**
 * Escapes `text` and wraps any emoji in `<span class="emoji">…</span>` so they
 * render via the system emoji font stack (see `.emoji` in index.scss) instead of
 * the page body font.
 *
 * Why: our web body font (Open Sans, via @nuxt/fonts) includes a catch-all
 * `@font-face` with no `unicode-range`, so an emoji in text makes the browser
 * download the full ~69KB woff just to discover it has no emoji glyph. Giving the
 * emoji their own font-family (that excludes Open Sans) avoids that download.
 *
 * Returns HTML intended for `v-html`; user text is HTML-escaped first, so only the
 * spans we add are markup.
 */
export function wrapEmoji(text: string | null | undefined): string {
  if (!text) return '';
  return escapeHtml(text).replace(EMOJI_RE, m => `<span class="emoji">${m}</span>`);
}
